import Types from "@redux/types/auth/forgot-password.type";

const initialState = {
    onRequest: false,
    forgotPasswordState: "",
    isActivated: false,
    data: {},
};

const ForgotPassword = (state = initialState, action) => {
    switch (action.type) {
        case Types.FORGOT_PASSWORD_REQUEST: {
            return {
                ...state,
                onRequest: true,
            };
        }
        case Types.FORGOT_PASSWORD_CHECK: {
            const { forgotPasswordState, statusMessage, token, data } = action.payload
            console.log(data, forgotPasswordState);
            return {
                ...state,
                onRequest: false,
                forgotPasswordState,
                statusMessage,
                token,
                data
            };
        }
        case Types.FORGOT_PASSWORD_ERROR: {
            const { forgotPasswordState, statusMessage } = action.payload
            return {
                ...state,
                forgotPasswordState, 
                statusMessage,
                onRequest: false,
            };
        }

        default: {
            return state;
        }
    }
};

export default ForgotPassword;
